import React, { useEffect, useState } from "react"
import { motion } from 'framer-motion'
import { FaPlus } from 'react-icons/fa'
import { useHistory } from 'react-router-dom'
import API from "../../Common/API"
import { useDispatch, useSelector } from "react-redux"
import { setAlert } from "../../Store/Theme/actions"
import * as Yup from 'yup'
import { useFormik } from "formik"
import Dialog from "../../Components/Dialog"
import FieldInput from "../../Components/FieldInput"
import Button from "../../Components/Button"

const AddAddress = () => {

    const history = useHistory()
    const [addList, setAddList] = useState([])
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(true)
    const [count, setCount] = useState(0)
    const [formData, setFormData] = useState({})
    const [openEditDialog, setOpenEditDialog] = useState(false)
    const [submitDisabled, setSubmitDisabled] = useState(false)
    const userDetails = useSelector((state) => state.auth.userDetails)
    const [openRemoveDialog, setOpenRemoveDialog] = useState(false)
    const [address, setAddress] = useState()

    useEffect(() => {
        setLoading(true)
        API.get('/users/getDeliveryAddress').then((addRes) => {
            if (addRes.status === 200) {
                setAddList(addRes.data.data)
                setLoading(false)
            }
        }).catch((err) => {
            dispatch(setAlert({ title: 'Error', subtitle: "Something went wrong", active: true, type: 'error' }))
        })
    }, [count])


    const markDefault = (values) => {
        API.post('/users/markDefault', values).then((defaultRes) => {
            if (defaultRes.status === 200) {
                dispatch(setAlert({ title: "Success", subtitle: 'Address marked as default', active: true, type: 'success' }))
                setCount(count + 1)
            }
        }).catch((err) => {
            dispatch(setAlert({ title: "Success", subtitle: 'Something went wrong', active: true, type: 'success' }))
        })
    }


    const addressFormSchema = Yup.object().shape({
        name: Yup.string().required("Name is required"),
        mobileNumber: Yup.string().required("Mobile number is required"),
        alternateMobile: Yup.string().nullable(),
        defaultAddress: Yup.boolean(),
        addressLine1: Yup.string().required("Address Line1 is requried"),
        addressLine2: Yup.string().nullable(),
        city: Yup.string().required("City is required"),
        state: Yup.string().required("State is required"),
        district: Yup.string().required("District is required"),
        pinCode: Yup.string().required("PinCode is required"),
        landMark: Yup.string().nullable(),
    })

    const addressForm = useFormik({
        initialValues: formData,
        validateOnMount: true,
        validationSchema: addressFormSchema,
        enableReinitialize: true,
        onSubmit: (values) => {
            setSubmitDisabled(true)
            values.addedBy = userDetails.subject._id
            API.post('/users/editDeliveryAddress', values).then((addRes) => {
                if (addRes.status === 200) {
                    dispatch(setAlert({ title: 'Success', subtitle: 'Address edited successfully', active: true, type: 'success' }))
                    setCount(count + 1)
                    closeEdit()
                    setSubmitDisabled(false)
                }
            }).catch((err) => {
                dispatch(setAlert({ title: 'Error', subtitle: 'Something went wrong', active: true, type: 'error' }))
            })
        }
    })

    const getLocation = (values) => {
        if (values.length === 6) {
            API.post('/common/getLocationByCode', { pinCode: values }).then((res) => {
                if (res.status === 200) {
                    const place = res.data.data
                    addressForm.setValues({ ...addressForm.values, city: place.city, district: place.district, state: place.state })
                }
            })
        } else {
            addressForm.setValues({ ...addressForm.values, city: '', district: '', state: '' })
        }
    }

    const editAddress = (values) => {
        setFormData(values)
        setOpenEditDialog(true)
    }

    const closeEdit = () => {
        setOpenEditDialog(false)
        addressForm.resetForm()
        setFormData({})
    }

    const removeAddress = (values) => {
        setAddress(values)
        setOpenRemoveDialog(true)
    }

    const confirmRemove = () => {
        try {
            API.post('/users/removeDeliveryAddress', address).then((removeRes) => {
                if (removeRes.status === 200) {
                    dispatch(setAlert({ title: 'Success', subtitle: 'Address removed successfully', active: true, type: 'success' }))
                    setCount(count + 1)
                    setOpenRemoveDialog(false)
                }
            }).catch((err) => {
                dispatch(setAlert({ title: 'Error', subtitle: 'Something went wrong', active: true, type: 'error' }))
            })
        } catch (err) {
            console.log(err)
        }
    }

    return (
        <>
            {
                loading ? "loading please wait..." : <motion.div className="flex flex-col w-full min-h-screen justify-center items-center overflow-y-scroll relative px-20 py-5">
                    <motion.div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 gap-5">
                        <motion.div className="w-72 border border-grey border-dashed h-72 flex flex-col justify-center items-center text-center" onClick={() => history.push('/createAddress')}>
                            <FaPlus className="my-2" />&nbsp;
                            <p className="text-md font-bold">Add Address</p>
                        </motion.div>
                        {
                            addList && addList.length > 0 && addList.filter((x) => x.defaultAddress).map((address, i) => {
                                return <motion.div key={i} className="w-72 h-72 border rounded px-5 justify-center border-grey drop-shadow-md flex flex-col gap-1 py-2">
                                    <motion.div className="flex flex-row w-full font-bold text-md">
                                        <p className="text-primeColor">Default</p>
                                    </motion.div>
                                    <p className="font-bold">{address.name}</p>
                                    <p>{address.addressLine1},</p>
                                    {address.addressLine2 && <p>{address.addressLine2},</p>}
                                    <p>{address.city},</p>
                                    <p>{address.district} - {address.pinCode},</p>
                                    <p>{address.state}</p>
                                    <p>{address.mobileNumber}</p>
                                    <p>{address.alternateMobile}</p>
                                    <motion.div className="flex flex-row justify-start w-full">
                                        <p className="text-primeColor cursor-pointer" onClick={() => editAddress(address)}>Edit</p> &nbsp;|&nbsp;
                                        <p className="text-primeColor cursor-pointer" onClick={() => removeAddress(address)}>Remove</p>
                                    </motion.div>
                                </motion.div>
                            })
                        }
                        {
                            addList && addList.length > 0 && addList.filter((x) => !x.defaultAddress).map((address, i) => {
                                return <motion.div key={i} className="w-72 h-72 border rounded px-5 justify-center border-grey drop-shadow-md flex flex-col gap-1 py-2">
                                    <p className="font-bold">{address.name}</p>
                                    <p>{address.addressLine1},</p>
                                    {address.addressLine2 && <p>{address.addressLine2},</p>}
                                    <p>{address.city},</p>
                                    <p>{address.district} - {address.pinCode},</p>
                                    <p>{address.state}</p>
                                    <p>{address.mobileNumber}</p>
                                    <p>{address.alternateMobile}</p>
                                    <motion.div className="flex flex-row justify-between w-full">
                                        <p className="text-primeColor cursor-pointer" onClick={() => editAddress(address)}>Edit</p> &nbsp;|&nbsp;
                                        <p className="text-primeColor cursor-pointer" onClick={() => removeAddress(address)}>Remove</p> &nbsp;|&nbsp;
                                        <p className="text-primeColor cursor-pointer" onClick={() => markDefault(address)}>Mark as default</p>
                                    </motion.div>
                                </motion.div>
                            })
                        }
                    </motion.div>
                </motion.div>
            }
            <Dialog title={'Edit Address'} injectClass={'w-[460px]'} showDialog={openEditDialog} onClose={() => closeEdit()}>
                <motion.div className="grid grid-cols-1 w-96 px-5 py-2">
                    <FieldInput label={'Name'} outerInjectClass={'w-96'} fieldHelper={addressForm.getFieldHelpers('name')} fieldMeta={addressForm.getFieldMeta('name')} fieldProps={addressForm.getFieldProps('name')} edit={true} dataLoaded={true} />
                    <FieldInput type={'phone'} label={'Mobile Number'} outerInjectClass={'w-96'} fieldHelper={addressForm.getFieldHelpers('mobileNumber')} fieldMeta={addressForm.getFieldMeta('mobileNumber')} fieldProps={addressForm.getFieldProps('mobileNumber')} edit={true} dataLoaded={true} />
                    <FieldInput type={'phone'} label={'Alternate Mobile Number'} outerInjectClass={'w-96'} fieldHelper={addressForm.getFieldHelpers('alternateMobile')} fieldMeta={addressForm.getFieldMeta('alternateMobile')} fieldProps={addressForm.getFieldProps('alternateMobile')} edit={true} dataLoaded={true} />
                    <FieldInput label={'Pincode'} outerInjectClass={'w-96'} fieldHelper={addressForm.getFieldHelpers('pinCode')} fieldMeta={addressForm.getFieldMeta('pinCode')} fieldProps={addressForm.getFieldProps('pinCode')} edit={true} dataLoaded={true} onChange={(ev) => getLocation(ev)} />
                    <FieldInput label={'Address Line 1'} outerInjectClass={'w-96'} fieldHelper={addressForm.getFieldHelpers('addressLine1')} fieldMeta={addressForm.getFieldMeta('addressLine1')} fieldProps={addressForm.getFieldProps('addressLine1')} edit={true} dataLoaded={true} />
                    <FieldInput label={'Address Line 2'} outerInjectClass={'w-96'} fieldHelper={addressForm.getFieldHelpers('addressLine2')} fieldMeta={addressForm.getFieldMeta('addressLine2')} fieldProps={addressForm.getFieldProps('addressLine2')} edit={true} dataLoaded={true} />
                    <FieldInput label={'City'} outerInjectClass={'w-96'} fieldHelper={addressForm.getFieldHelpers('city')} fieldMeta={addressForm.getFieldMeta('city')} fieldProps={addressForm.getFieldProps('city')} edit={true} dataLoaded={true} />
                    <FieldInput label={'District'} outerInjectClass={'w-96'} fieldHelper={addressForm.getFieldHelpers('district')} fieldMeta={addressForm.getFieldMeta('district')} fieldProps={addressForm.getFieldProps('district')} edit={true} dataLoaded={true} />
                    <FieldInput label={'State'} outerInjectClass={'w-96'} fieldHelper={addressForm.getFieldHelpers('state')} fieldMeta={addressForm.getFieldMeta('state')} fieldProps={addressForm.getFieldProps('state')} edit={true} dataLoaded={true} />
                    <FieldInput label={'Land Mark'} placeholder={'Optional'} outerInjectClass={'w-96'} fieldHelper={addressForm.getFieldHelpers('landMark')} fieldMeta={addressForm.getFieldMeta('landMark')} fieldProps={addressForm.getFieldProps('landMark')} edit={true} dataLoaded={true} />
                    <motion.div className="flex px-5 flex-row w-full items-center">
                        <input type="checkbox" value={addressForm.values.defaultAddress} checked={addressForm.values.defaultAddress} onChange={(ev) => { addressForm.setValues({ ...addressForm.values, defaultAddress: ev.target.checked }) }}></input>&nbsp;<p>Mark as default address</p>
                    </motion.div>
                    <motion.div className="w-full my-10 flex flex-row justify-between">
                        <Button injectClass={'bg-[red]/20 rounded-md ring-[red] cursor-pointer'} onClick={() => closeEdit()}>Cancel</Button>
                        <Button injectClass={`bg-[green]/20 rounded-md ring-[green] ${submitDisabled ? 'cursor-not-allowed' : 'cursor-pointer'}`} onClick={() => !submitDisabled && addressForm.submitForm()}>Save</Button>
                    </motion.div>
                </motion.div>
            </Dialog>
            <Dialog title={'Remove Address'} injectClass={'w-[460px]'} showDialog={openRemoveDialog} onClose={() => { setAddress({}); setOpenRemoveDialog(false) }}>
                <motion.div className="flex flex-col w-full text-black gap-2">
                    <p>Are you sure you want to remove this address ?</p>
                    <motion.div className="w-full my-10 flex flex-row justify-between">
                        <Button injectClass={'bg-[red]/20 rounded-md ring-[red] cursor-pointer'} onClick={() => { setAddress({}); setOpenRemoveDialog(false) }}>No</Button>
                        <Button injectClass={`bg-[green]/20 rounded-md ring-[green] ${submitDisabled ? 'cursor-not-allowed' : 'cursor-pointer'}`} onClick={() => confirmRemove()}>Yes</Button>
                    </motion.div>
                </motion.div>
            </Dialog>
        </>
    )
}

export default AddAddress